import status from "./status";
import qrcode from "./qrcode";
export const baseUrl = "/company/:company_id/kycs-biometry";
export default (axiosConfig, options) => ({
  status: status(axiosConfig, options),
  qrcode: qrcode(axiosConfig, options)
});